import type { TFunction } from "i18next";
import type { HistoryPerson } from "../../api/people";
import type { ProjectRuleName } from "../../api/settingsApi";

/** The name of a project rule, as the settings page and the history show it. */
export function ruleName(t: TFunction, rule: ProjectRuleName): string {
  return t(`projects.settings.rules.names.${rule}`);
}

/** A person's display name; a removed account is named as such. */
export function personName(t: TFunction, person: HistoryPerson | null): string {
  return person?.displayName ?? t("permissionHistory.removedAccount");
}
